import { createModel } from "hox";
import { useState } from "react"
import { ITeamDetail, ITeamSearch, IMD5ImgField, ITeamField } from "./TeamTypes"
import { teamService } from "./teamService";
import { message } from "antd";
import { TablePaginationConfig } from "antd/lib/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage } from "@/types/AppTypes";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { globalPrompt } from "@/components/message";
interface IRestaurantType {
    visible: boolean,
    mode: "add" | "edit" | "look"
}
export const useTeamModel = createModel(function () {
    const { user } = useGlobalModel()

    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //列表数据
    const [dataSource, setDataSource] = useState<ITeamDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ITeamField>({});
    //分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const initMd5 = {
        "id": "",
        "imgMd5": "",
        "imgTitle": "",
        "honorId": ""
    }
    const [selectedRow, setSelectedRow] = useState<ITeamField[]>([]);
    const [md5FormVal, setMd5FormVal] = useState<string[]>([]) //图片md5值
    const [md5List, setMd5List] = useState<IMD5ImgField[]>([initMd5]) //图片md5值

    //抽屉框
    const initShopDrawer: IRestaurantType = { visible: false, mode: "add" }
    const [visibleDrawer, setVisibleDrawer] = useState<IRestaurantType>(initShopDrawer);
    const setIVisibleDrawer = (str?: "add" | "edit" | "look") => setVisibleDrawer(str ? { visible: true, mode: str } : initShopDrawer);


    //设置搜索value
    const updateSearchParam = (updateParam: ITeamField) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: ITeamField = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await teamService.page(searchParams);
        const { items, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(items);
    }
    //新增团队风采
    const insertDetail = useLockFn(async (params: ITeamField) => {
        let newMd5List = md5FormVal.map((item) => {
            return {
                imgMd5: item,
                id: "",
                imgTitle: "",
                honorId: ""
            }
        })
        let { retData } = await teamService.insert({ ...params, createUser: user.userName, list: newMd5List });
        if (retData) {
            loadData();
            setIVisibleDrawer();
            globalPrompt("message", { text: "团队风采新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "团队风采新增失败", type: "success" })
        }
    })
    //编辑团队风采
    const editDetail = useLockFn(async (params: ITeamField) => {
        // debugger;
        // let newMd5List: IMD5ImgField[] = [];
        // console.log(md5FormVal, md5List)
        // md5FormVal.forEach((formItem, formInd, formArr) => {
        //     md5List.length!== 0 ?md5List.forEach((listItem, listInd, listArr) => {
        //         if (formInd === listInd) {
        //             let { imgMd5, ...item } = listItem
        //             newMd5List.push({ ...item, imgMd5: formItem })
        //         } else if (formArr.length > listArr.length) {
        //             newMd5List.push({ ...initMd5, imgMd5: formItem })
        //         }
        //     }):newMd5List.push({ ...initMd5, imgMd5: formItem })
        // })
        let newMd5List = md5FormVal.map((item) => {
            return {
                imgMd5: item,
                id: "",
                imgTitle: "",
                honorId: ""
            }
        })        
        let { retData } = await teamService.update({ ...params, id: selectedRow[0].id, updateUser: user.userName, list:newMd5List})
        if (retData) {
            loadData();
            setIVisibleDrawer();
            setSelectedRowKeys([])
            globalPrompt("message", { text: "团队风采编辑成功", type: "success" })
        } else {
            globalPrompt("message", { text: "团队风采编辑失败", type: "success" })
        }
    })
    const onRemove = useLockFn(async (id: string) => {
        let { retData } = await teamService.delete(id)
        if (retData) {
            loadData();
            globalPrompt("message", { text: "团队风采删除成功", type: "success" })
        }
    })
    return {
        dataSource,
        searchParam,
        pgCfg,
        selectedRowKeys,
        initPgCfg,
        selectedRow,
        visibleDrawer,
        md5FormVal,
        setSelectedRowKeys,
        setPgCfg,
        setSearchParam,
        setDataSource,
        updateSearchParam,
        resetSearchParam,
        loadData,
        setSelectedRow,
        setVisibleDrawer,
        setIVisibleDrawer,
        insertDetail,
        editDetail,
        onRemove,
        setMd5FormVal,
        md5List, setMd5List
    }
})